require("writing/essays/static_essay_display.scss")
import DOMPurify from 'dompurify';

class StaticEssayDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.iframeRef = React.createRef();
    }

    componentDidMount() {
        this.setupIframe();
    }

    getEssayText(){
        if (!this.props.answer || !this.props.answer.parts || !this.props.answer.parts[0]){
            return ""
        }

        var essayText = this.props.answer.parts[0].text
        essayText = essayText.replace(/<p><br><\/p>/g, "")
        return DOMPurify.sanitize(essayText)
    }

    setupIframe = () => {
        const iframe = this.iframeRef.current;

        // Your HTML content
        const essayText = this.getEssayText()
        const styledEssayText = `
        <!DOCTYPE html>
        <html lang="en">
            <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <link href="https://fonts.cdnfonts.com/css/museo-sans-rounded" rel="stylesheet">
            <style>
                body {
                font-family: Museo Sans Rounded, Helvetica, Arial, sans-serif;
                font-size: 16px;
                line-height: 1.428571429;
                color: #555;
                margin: 0;
                font-weight: 300;
                }
            </style>
            </head>
            <body>${essayText}</body>
        </html>
        `;

        // Set the srcDoc with your HTML content
        iframe.srcdoc = styledEssayText;

        // Function to resize the iframe based on its content
        const resizeIframe = () => {
            if (iframe.contentWindow && iframe.contentWindow.document) {
                const contentHeight = iframe.contentWindow.document.body.scrollHeight;
                iframe.style.height = (contentHeight + 12)+ 'px';
            }
        };

        // Call the resizeIframe function after the iframe content has loaded
        iframe.onload = () => {
            resizeIframe();
        };

        // Cleanup: Remove the onload event listener when the component unmounts
        this.cleanupIframe = () => {
            iframe.onload = null;
        };
    };

    componentWillUnmount() {
        this.cleanupIframe();
    }

    render() {
        return (
            <iframe
            ref={this.iframeRef}
            className='StaticEssayDisplay'
            frameBorder="0"
            scrolling="no"
            style={{ width: '100%', border: 'none' }}
            />
        );
    }
}

module.exports = StaticEssayDisplay


// WEBPACK FOOTER //
// ./modules/components/writing/essays/StaticEssayDisplay.js